import { Card, CardContent, makeStyles } from '@material-ui/core'
import { blue, green, indigo, orange, pink, purple, red, yellow } from '@material-ui/core/colors'

import { Theme } from '@material-ui/core/styles'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { usePrevious } from '../util/reactUtils'
import {
	addTts, compareTts, getLineIndexFromTt, getLineMaxTt, getLineMinTt, getPositionFromTt, getTotalTtDuration, getTtAndLineIndexFromXY,
	getWidthFromTtDuration, hasNextAdjacentChord, isChordStartOfSection, isIndexInRanges, isTtInBetween, substractTts, ttTo16th
} from '../util/utils'
import EditorChordCardInput from './EditorChordCardInput'
import { EditorActionType } from './editorStore/backingTrackGeneratorEditorActions'
import BackingTrackGeneratorEditorContext from './editorStore/BackingTrackGeneratorEditorContext'
// import BackingTrackGeneratorSectionsContext from './sectionsStore/BackingTrackGeneratorSectionsContext'

import { DraggableCore } from 'react-draggable'
import { DRAG_TIMEOUT, ROMAN_DEGREES } from '../util/constants'
import ChordProgressionSuggestions from './ChordProgressionSuggestions'

const degreesColors = [
  red[300],
  orange[300],
  yellow[300],
  green[300],
  blue[300],
  purple[300],
  pink[300],
]


type Props = {
	selected: boolean,
	hasMarginLeft: boolean,
	hasBackground: boolean,
	left: number | undefined,
	top: number,
	width: number,
	hasAnimation: boolean,
	hasBorderLeft: boolean,
	hasBorderRight: boolean,
	isSelected: boolean,
  degreeColor: string
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
	container: {
		// marginLeft: 2,
	},
	containerLast: {
		position: 'relative',
		textAlign: 'center',
	},
	card: {
		textAlign: 'center',
		cursor: 'pointer',
		// '&:hover': {
		// }
		// width: first ? 210 - 2 : 260,
		height: 120,
		display: 'flex',
		alignContent: 'center',
		justifyContent: 'center',
		margin: 0,
		marginLeft: ({ hasMarginLeft }) => hasMarginLeft ? -4 : 0,
		// cursor: 'pointer',
		borderRadius: 0,
		backgroundColor: ({ hasBackground }) => hasBackground ? '#3a3c3e' : 'transparent',
		position: 'absolute',
		// left: delay ? undefined : left,
		// left: left + dragOffset,
		left: ({ left }) => left,
		top: ({ top }) => top,
		width: ({ width }) => width,
		
		transition: 'background-color ease 0.25s, left 0.25s ease, top 0.25s ease, width 0.25s ease',

		animation: ({ hasAnimation }) => hasAnimation ? '0.25s ease 0s slidein' : undefined,

		zIndex: ({ isSelected }) => isSelected ? 5 : 4,
		
		overflow: 'visible',// for suggestions
	},
	cardContent: {
		borderTop: ({ degreeColor }) => '6px solid ' + degreeColor,
		borderBottom: ({ degreeColor }) => '6px solid ' + degreeColor,
		borderRadius: 4,
		padding: 0,

		transition: 'width 0.25s ease',
		width: ({ width }) => width,
		// overflow: 'hidden',

		position: 'relative',// for suggestions
		overflow: 'visible',
	},
	cardContent2: {
		borderLeft: ({ hasBorderLeft }) => hasBorderLeft ? '2px dashed #393939' : 'none',
		borderRight: ({ hasBorderRight }) => hasBorderRight ? '2px dashed #393939' : 'none',
		width: ({ width, hasBorderLeft, hasBorderRight }) => width - (hasBorderLeft ? 2 : 0) - (hasBorderRight ? 2 : 0),
	},
	iconButtonPlay: {
		position: 'absolute',
		opacity: 0,
		right: 4,
		top: 4,
		width: 42,
		height: 42,
		color: 'darkgrey',
		transition: 'color 0.25s, opacity 0.25s',
		'&:hover': {
			color: 'lightgray',
		},
	},
	iconPlay: {
		fontSize: 24,
	}
}))

const EditorChordCard = (props: {
	// onPlayClick: (chords: any[]) => void
	selected?: boolean
	// first: boolean,
	chordIndex: number
	lineIndex: number
	cross: number,
	// sectionIndex: number
	isPostInit: boolean,
	onMouseMove: (e: any) => void,// needed to move cursor event if mouse if over card
}) => {

	const {
		selected = false,
		// onPlayClick,
		// first,
		chordIndex,
		lineIndex,
		// sectionIndex,
		isPostInit,
		onMouseMove,
	} = props

	// const [sections] = useContext(BackingTrackGeneratorSectionsContext)

	const [editor, dispatchEditor] = useContext(BackingTrackGeneratorEditorContext)

	const [hover, setHover] = useState(false)


	// console.log({ EditorChordCard: sections })

	const chords = editor.fakeChords || editor.chords
	
	const chord = chords[chordIndex]
	

	const isSelected = isIndexInRanges(chordIndex, editor.state.chordSelectedRanges)
	const isEdit = editor.state.chordEditIndex === chordIndex


	const [isPostInitState, setIsPostInitState] = useState(false)

	useEffect(() => {
		setIsPostInitState(isPostInit)
	}, [])

	const prevChord = usePrevious(chord)
	
	// console.log({ chord, fakeChords: JSON.stringify(editor.fakeChords), chordIndex })

	// console.log({ actTt: chord.transportTime })

	const { left, top } = getPositionFromTt(editor.sections, chord.transportTime, lineIndex)
	const width = getWidthFromTtDuration(chord.transportTimeDuration)

	const hasAnimation = compareTts(addTts(chord.transportTime, '5:0'), getTotalTtDuration(editor.sections)) <= 0 && isPostInitState
		&& prevChord && compareTts(chord.transportTime, prevChord.transportTime) === 0
		// && (!prevChord || (prevChord && compareTts(chord.transportTime, prevChord.transportTime) === -1))
		&& left <= 0
	
	const isDrag = isIndexInRanges(chordIndex, editor.state.chordSelectedRanges) && editor.fakeChords !== undefined
	const [isDrag2, setIsDrag2] = useState(isDrag)

	// TODO : verify if chords are tt contiguous
	const hasSuggestion = editor.state.chordSelectedRanges.length === 1 && chordIndex === editor.state.chordSelectedRanges[0][0] && editor.state.chordSelectedRanges[0][1] - editor.state.chordSelectedRanges[0][0] >= 1

	console.log({ hasSuggestion, isDrag, cRange: editor.state.chordSelectedRanges, chordIndex })

	const handleMouseOver = () => {// used to disabled hover when cursor Drag is active
		setHover(true)
	}

	const handleMouseOut = () => {
		setHover(false)
	}

	// const [initialDrag, setInitialDrag] = useState<number | undefined>(undefined)
	// const [mouseX, setMouseX] = useState<number | undefined>(undefined)

	const classes = useStyles({
		selected,
		hasMarginLeft: left + width < ttTo16th('0:0:1'),
		hasBackground: editor.state.playTransportTime && isTtInBetween(editor.state.playTransportTime, chord.transportTime, chord.transportTimeDuration) ||
			isSelected || (hover && editor.state.initialCursorDragTt === undefined && editor.fakeChords === undefined),
		left,
		top,
		width,
		hasAnimation,
		hasBorderLeft: !isChordStartOfSection(editor.sections, chord),
		hasBorderRight: !hasNextAdjacentChord(chords, chord),
		isSelected,
		degreeColor: chord.degreeName ? degreesColors[ROMAN_DEGREES.findIndex((d: string) => d === chord.degreeName!.split(' ')[0].toUpperCase())] : indigo[300]
	})

	/*
	
	<--------> 	e.pageX
	<------> 		rect.left
	<-> 				.offsetLeft
	   
		<----> 		output

	rect.left - offsetLeft
	*/
	const containerEl = useRef<any>(undefined)
	
	const dragOffset = useRef({
		x: 0,
		y: 0,
	})
	const currChordSelectDragTt = useRef<string | undefined>(undefined)
	const initialCardOffset = useRef<any>(undefined)
	// const chordTt = useRef<any>(undefined)

	useEffect(() => { currChordSelectDragTt.current = editor.state.currChordSelectDragTt }, [editor.state.currChordSelectDragTt])


	/*
		line -> changeLine -> newState -> mouseMove
		mouseMove -> move
	*/

	const editorRect = useRef<any | undefined>({
		top: 0,
		left: 0
	})
	useEffect(() => {
		const rect = document.getElementById('backing-track-editor')!.firstElementChild!.getBoundingClientRect()
		editorRect.current = {
			left: rect.left + window.scrollX,
			top: rect.top + window.scrollY,
		}
		console.log({ editorRect: editorRect.current })
	}, [])

	// useEffect(() => {
	// 	chordTt.current = chord.transportTime
	// }, [chord])

	const initialDragPos = useRef<any>(undefined)

	// const [hasEvent, setHasEvent] = useState(false)

	const getTtAndLineIndex = (e: any) => {

		// console.log({ actGetTt: chordTt.current })

		dragOffset.current = {
			x: dragOffset.current.x + e.movementX,
			y: dragOffset.current.y + e.movementY,
		}

		// console.log({ editorRect: editorRect.current, initialCardOffset: initialCardOffset.current })
		
		// const x = getLeftPositionFromTt2(editor.sections, sectionIndex, editor.chords[chordIndex].transportTime, lineIndex) + dragOffset.current.x
		// const x = (e.pageX - editorRect.current!.left) + DISTANCE_FROM CARD TOP_LEFT// + dragOffset.current.x
		const x = (initialDragPos.current ? initialDragPos.current.x : e.pageX) + dragOffset.current.x - initialCardOffset.current.x - editorRect.current!.left

		// Maybe needs an offset here
		// const y = (e.pageY - editorRect.current!.top)// + dragOffset.current.y
		const y = (initialDragPos.current ? initialDragPos.current.y : e.pageY) + dragOffset.current.y/* - initialCardOffset.current.y*/ - editorRect.current!.top

		console.log({ x, y, pageX: e.pageX, pageY: e.pageY, iDp: initialDragPos.current, dcy: dragOffset.current.y, ecp: editorRect.current!.top })

		// console.log({ x, y, currTt: currChordSelectDragTt.current })

		// return getTtFromXY(x, y, editor.sections)
		const { tt, globalLineIndex } = getTtAndLineIndexFromXY(x, y, editor.sections, currChordSelectDragTt.current)
		// return addTts((getLineIndexFromTt(chordTt.current) * BARS_BY_LINE) + ':0' , getTtFromX(x))
		// return getTtFromX(x)

		return {
			tt: ttTo16th(tt) < 0 ? '0:0' : tt,
			globalLineIndex,
		}
	}

	// const handleMouseDown = (e: any) => {
	// 	e.stopPropagation()

	// 	console.log({ t: 'CardMouseDown, binding window drag events' })

	// 	initialDragPos.current = {
	// 		x: e.pageX,
	// 		y: e.pageY,
	// 	}

		
	// 	const rect = containerEl.current.getBoundingClientRect()
		
	// 	console.log({ containerEl: containerEl.current, rect, mPos: { x: e.pageX, y: e.pageY } })
	// 	initialCardOffset.current = {
	// 		x: e.pageX - rect.left,
	// 		y: e.pageY - rect.top,
	// 	}

	// 	const { tt, globalLineIndex } = getTtAndLineIndex(e)

	// 	console.log('binding window click listener')
	// 	window.addEventListener('mousemove', handleMouseMove)
	// 	window.addEventListener('click', handleWindowClick)

	// 	setHasEvent(true)

	// 	dispatchEditor({
	// 		type: EditorActionType.ChordSelectDragStart,
	// 		payload: {
	// 			chordIndex,
	// 			transportTime: tt,
	// 			globalLineIndex,
	// 		}
	// 	})
	// }

	const handleDragStart = (e: any) => {
		// e.stopPropagation()

		console.log({ t: 'CardDragStart', pageX: e.pageX })

		console.log({ e })

		initialDragPos.current = {
			x: e.pageX,
			y: e.pageY,
		}

		
		const rect = containerEl.current.getBoundingClientRect()
		
		console.log({ containerEl: containerEl.current, rect, mPos: { x: e.pageX, y: e.pageY } })
		initialCardOffset.current = {
			x: e.pageX - rect.left,
			y: e.pageY - rect.top,
		}

		const { tt, globalLineIndex } = getTtAndLineIndex(e)

		dispatchEditor({
			type: EditorActionType.ChordSelectDragStart,
			payload: {
				chordIndex,
				transportTime: tt,
				globalLineIndex,
			}
		})
	}

	// const handleMouseMove = (e: any) => {
	// 	// if (editor.fakeChords === undefined) return

	// 	// TODO : see if there are any better solutions, like put lineIndex in state/reducer, how to handle chord ranges ?
	// 	// 		need the id of the element being dragged (put this in reducer)

	// 	// console.log({ t: 'MouseMove, calling dragging action' })


	// 	const { tt, globalLineIndex } = getTtAndLineIndex(e)

	// 	const ttGlobalLineIndex = getLineIndexFromTt(tt)

	// 	const ttGlobalLineIndexEnd = getLineIndexFromTt(substractTts(addTts(tt, chord.transportTimeDuration), '0:0:1'))

	// 	const minTt = ttGlobalLineIndexEnd < globalLineIndex ? getLineMinTt(globalLineIndex, chord.transportTimeDuration) : undefined
	// 	const maxTt = globalLineIndex < ttGlobalLineIndex ? getLineMaxTt(globalLineIndex) : undefined

	// 	// console.log({ minTt, maxTt, tt, globalLineIndex, ttGlobalLineIndex, ttGlobalLineIndexEnd })
			
	// 	if (tt !== currChordSelectDragTt.current) {
	// 		dispatchEditor({
	// 			type: EditorActionType.ChordSelectDrag,
	// 			payload: {
	// 				transportTime: globalLineIndex === ttGlobalLineIndex || globalLineIndex === ttGlobalLineIndexEnd ? tt : maxTt ? maxTt : minTt,
	// 				globalLineIndex,
	// 			}
	// 		})
	// 	}
	// }

	const handleDrag = (e: any) => {
		// if (editor.fakeChords === undefined) return

		// TODO : see if there are any better solutions, like put lineIndex in state/reducer, how to handle chord ranges ?
		// 		need the id of the element being dragged (put this in reducer)

		console.log({ t: 'handleDrag' })


		const { tt, globalLineIndex } = getTtAndLineIndex(e)

		const ttGlobalLineIndex = getLineIndexFromTt(tt)

		const ttGlobalLineIndexEnd = getLineIndexFromTt(substractTts(addTts(tt, chord.transportTimeDuration), '0:0:1'))

		const minTt = ttGlobalLineIndexEnd < globalLineIndex ? getLineMinTt(globalLineIndex, chord.transportTimeDuration) : undefined
		const maxTt = globalLineIndex < ttGlobalLineIndex ? getLineMaxTt(globalLineIndex) : undefined

		// console.log({ minTt, maxTt, tt, globalLineIndex, ttGlobalLineIndex, ttGlobalLineIndexEnd })
			
		if (tt !== currChordSelectDragTt.current) {
			dispatchEditor({
				type: EditorActionType.ChordSelectDrag,
				payload: {
					// transportTime: globalLineIndex === ttGlobalLineIndex || globalLineIndex === ttGlobalLineIndexEnd ? tt : maxTt ? maxTt : minTt,
					transportTime: ttGlobalLineIndex <= globalLineIndex && globalLineIndex <= ttGlobalLineIndexEnd ? tt : maxTt ? maxTt : minTt,// TOTEST : test this with animations
					globalLineIndex,
				}
			})
		}
	}
	
	// const handleWindowClick = (e: any) => {
	// 	// if (editor.fakeChords === undefined) return
	// 	// e.stopPropagation()
	// 	console.log({ t: 'WindowClick, unbinding window drag events' })
		
	// 	const { tt, globalLineIndex } = getTtAndLineIndex(e)

	// 	const ttGlobalLineIndex = getLineIndexFromTt(tt)

	// 	const ttGlobalLineIndexEnd = getLineIndexFromTt(substractTts(addTts(tt, chord.transportTimeDuration), '0:0:1'))

	// 	console.log({ chordTtD: chord.transportTimeDuration })

	// 	const minTt = ttGlobalLineIndexEnd < globalLineIndex ? getLineMinTt(globalLineIndex, chord.transportTimeDuration) : undefined
	// 	const maxTt = globalLineIndex < ttGlobalLineIndex ? getLineMaxTt(globalLineIndex) : undefined


	// 	// TODO : here tt is undefined, maybe cause e is a different event kind ?
	// 	dispatchEditor({
	// 		type: EditorActionType.ChordSelectDragEnd,
	// 		payload: {
	// 			transportTime: globalLineIndex === ttGlobalLineIndex || globalLineIndex === ttGlobalLineIndexEnd ? tt : maxTt ? maxTt : minTt,
	// 		}
	// 	})
		
	// 	dragOffset.current = {
	// 		x: 0,
	// 		y: 0
	// 	}
	// 	window.removeEventListener('mousemove', handleMouseMove)
	// 	window.removeEventListener('click', handleWindowClick)
	// 	setHasEvent(false)

	// }

	const handleDragEnd = (e: any) => {
		// if (editor.fakeChords === undefined) return
		// e.stopPropagation()
		console.log({ t: 'handleDragEnd' })
		
		const { tt, globalLineIndex } = getTtAndLineIndex(e)

		const ttGlobalLineIndex = getLineIndexFromTt(tt)

		const ttGlobalLineIndexEnd = getLineIndexFromTt(substractTts(addTts(tt, chord.transportTimeDuration), '0:0:1'))

		console.log({ chordTtD: chord.transportTimeDuration })

		const minTt = ttGlobalLineIndexEnd < globalLineIndex ? getLineMinTt(globalLineIndex, chord.transportTimeDuration) : undefined
		const maxTt = globalLineIndex < ttGlobalLineIndex ? getLineMaxTt(globalLineIndex) : undefined

		console.log({ globalLineIndex, ttGlobalLineIndex, ttGlobalLineIndexEnd, minTt, maxTt, tt, isMin: ttGlobalLineIndexEnd < globalLineIndex, isMax: globalLineIndex < ttGlobalLineIndex })

		// TODO : here tt is undefined, maybe cause e is a different event kind ?
		dispatchEditor({
			type: EditorActionType.ChordSelectDragEnd,
			payload: {
				// transportTime: globalLineIndex === ttGlobalLineIndex || globalLineIndex === ttGlobalLineIndexEnd ? tt : maxTt ? maxTt : minTt,
				transportTime: ttGlobalLineIndex <= globalLineIndex && globalLineIndex <= ttGlobalLineIndexEnd ? tt : maxTt ? maxTt : minTt,// TOTEST : test this with animations
			}
		})
		
		dragOffset.current = {
			x: 0,
			y: 0
		}

	}

	// Use to prevent input select after drag (mouseUp being fire before mouseClick fakeChords will already been undefined)
	// FIXME : This is a workaround
	useEffect(() => { setTimeout(() => setIsDrag2(isDrag), DRAG_TIMEOUT) }, [isDrag])

	const handleClick = (e: any) => {
		console.log('chordCard handleClick')
		
		if (isDrag2) {
		} else {
			dispatchEditor({
				type: EditorActionType.ChordSelect,
				payload: {
					index: chordIndex,
				}
			})
			e.stopPropagation()
		}
	}


	const renderCount = useRef(0)

	// console.log({ isEdit })


	return (
		<Card
			ref={containerEl}
			className={classes.card}
			elevation={0}
			onClick={handleClick}

			// onMouseMove={handleMouseMove}

			// onMouseDown={handleMouseDown}

			onMouseOver={handleMouseOver}
			onMouseOut={handleMouseOut}

			onMouseMove={onMouseMove}

			// onDragStart={handleDragStart}
			// onDrag={handleDrag}
			// onDragEnd={handleDragEnd}
			// draggable
		>

		{/* {renderCount.current++ + ' times'} */}

			<DraggableCore
				disabled={isEdit}
				onStart={handleDragStart}
				onDrag={handleDrag}
				onStop={handleDragEnd}
			>

				<CardContent
					style={{
						display: 'flex',
						flexGrow: 1,
						// margin: '3px 3px 0 3px'1
					}}
					className={classes.cardContent}
				>
					{hasSuggestion && (
						<ChordProgressionSuggestions hide={isDrag} />
					)}
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							justifyContent: 'center',
							flexDirection: 'row',
							flexGrow: 1,
							// margin: '3px 3px 0 3px'1
						}}
						className={classes.cardContent2}
					>
						<EditorChordCardInput
							chordIndex={chordIndex}
							isEdit={isEdit}
							isSelected={isSelected}
						/>
					</div>
				</CardContent>

				{/* <IconButton onClick={(e) => {e.stopPropagation(); onPlayClick(chord)}} className={classes.iconButtonPlay} edge="start" color="inherit" aria-label="play audio">
					<VolumeUpIcon className={classes.iconPlay} />
				</IconButton> */}

			</DraggableCore>

		</Card>
	)
}

export default EditorChordCard
